module.exports = __webpack_public_path__ + "img/2.064776f9.png";